<template>
    <div
        class="evo-flex evo-items-center evo-justify-center evo-w-full evo-h-full evo-min-h-screen"
    >
        <slot></slot>
    </div>
</template>
